import React, { useEffect, useRef } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { LeadFormCard } from '@/components/home/NexusLeadForm';

interface LeadFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  route: string;
  title?: string;
  description?: string;
  source?: string;
}

export const LeadFormModal: React.FC<LeadFormModalProps> = ({
  isOpen,
  onClose,
  route,
  title = 'Solicitar asesoría personalizada',
  description = 'Complete el formulario y un especialista de Nexus HR le contactará a la brevedad.',
  source,
}) => {
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (isOpen) {
      const current = window.location.pathname + window.location.search + window.location.hash;
      if (window.location.pathname !== route) {
        previousPathRef.current = current;
        window.history.pushState({ leadFormModal: true, route }, '', route);
      }
    }
  }, [isOpen, route]);

  useEffect(() => {
    const handlePopState = () => {
      if (isOpen) onClose();
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [isOpen, onClose]);

  const handleClose = () => {
    // Don't reverse URL if the form redirected to /gracias
    if (
      previousPathRef.current &&
      window.location.pathname === route &&
      !window.history.state?.leadThankYou
    ) {
      window.history.back();
    }
    previousPathRef.current = null;
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) handleClose(); }}>
      <DialogContent className="max-w-3xl w-[95vw] p-0 border-0 bg-transparent shadow-none max-h-[90vh] overflow-y-auto">
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <LeadFormCard title={title} description={description} source={source ?? (route === '/contacto' ? 'header' : route === '/solicitar-asesoria' ? 'hero-cta' : 'modal')} />
      </DialogContent>
    </Dialog>
  );
};

export default LeadFormModal;
